import React, { useState } from 'react';
import LabConfig from '../../../forms/labConfig';
import restApiClient from '../../../services/restApiClient';
import { Container, StyledCreateUpdateForm } from './styles';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

function LabConfigCreateUpdate(props) {
  const [alert, setAlert] = useState({ message: '', severity: '' });

  const handleAlertClose = () => {
    setAlert({ message: '', severity: '' });
  };

  return (
    <Container>
      <StyledCreateUpdateForm
        modelSchema={LabConfig}
        forceId={-1}
        restGetDataById={restApiClient.labConfig.getAll}
        restUpdateData={restApiClient.labConfig.update}
        onUpdateSuccess={() => {
          setAlert({
            message: 'As configurações foram salvas com sucesso!',
            severity: 'success',
          });
        }}
        {...props}
      />
      <Snackbar
        open={!!alert?.message}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={6000}
        onClose={handleAlertClose}
      >
        <Alert onClose={handleAlertClose} severity={alert?.severity}>
          {alert?.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}

export default LabConfigCreateUpdate;
